import { Phone } from "lucide-react";
import { Link } from "react-router-dom";

export const MobileCallButton = () => {
  return (
    <Link
      to="tel:+14195020007"
      className="md:hidden flex items-center justify-center h-12 w-12 rounded-full bg-blue-500/30 backdrop-blur-md border border-blue-400/50 hover:bg-blue-500/40 transition-all duration-300 shadow-lg hover:shadow-xl"
      aria-label="Call us"
      title="Call Enzo's Cleaning Solutions"
    >
      <Phone className="h-5 w-5 text-blue-400" />
    </Link>
  );
};
